var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dcw-blog-post-list"},[_vm._l((_vm.list),function(post){return [_c('li',{key:post.id},[_c('DcwBlogPost',{attrs:{"post":post}})],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }